import Quill from "quill";

export const TEXT_SIZES = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "32px",
  "36px",
  "48px",
  "60px",
  "72px",
];

const Size = Quill.import("attributors/style/size");

Size.whitelist = TEXT_SIZES;
Quill.register(Size, true);

